import type { Placement } from '@floating-ui/vue'
import type { MaybeArray } from './types'

const whitespaceRegex = /\s+/
const rgbNumberRegex = /\d+/g

export function createArray(length: number, startOffset: number = 0): number[] {
  return Array
    .from({ length })
    .map((_, index) => startOffset + index)
}

// Searches through the input and checkes wether it contains match
// It searches the input by splitting it by whitespace and matching each
// word against the string
export function searchString(match: MaybeArray<string | number | null | undefined>, input?: string): boolean {
  if (!input)
    return true

  if (!match)
    return false

  const joint: string = Array.isArray(match)
    ? match.filter(Boolean).join(' ')
    : match.toString()

  const split = input.trim().split(whitespaceRegex)
  // NOTE: should this be every or some?
  return split.every(s => joint.toLowerCase().includes(s.toLowerCase()))
}

export function getMaybeRefLength(value: string | number): number {
  return typeof value === 'number' ? value : value.length
}

export function isNil(value: any): value is undefined | null {
  return value === undefined || value === null
}

/**
 * Checks wether a color is light or dark, depending on
 */
export function calculateColorLightness(r: number, g: number, b: number): 'dark' | 'light' {
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? 'light' : 'dark'
}

/**
 * Convert a CSS rgb string to a tuple of actual r,g,b values
 *
 * 'rgb(12,16,24)' --> [12, 16, 24]
 */
export function stringRgbToValues(rgbString: string): [number, number, number] {
  return rgbString.match(rgbNumberRegex)!.map(Number) as any as [number, number, number]
}

// export function rgbToHex(r: number, g: number, b: number): string {
//   return `#${[r, g, b].map((x) => {
//     const hex = x.toString(16)
//     return hex.length === 1 ? `0${hex}` : hex
//   }).join('')}`
// }

export function randomMinMax(min: number, max: number): number {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function delay(amount: number): Promise<any> {
  return new Promise(r => setTimeout(r, amount))
}

export function setCharAt(str: string, char: string | number, index: number): string {
  if (str.length === 0)
    return char.toString()
  return str.substring(0, index) + char + str.substring(index + 1)
}

const unitRegex = /^(?:\d+(?:\.\d+)?|\.\d+)(?:px|em|rem|vh|vw|vmin|vmax|ch|ex|cm|mm|in|pt|pc|%)$/
const variableRegex = /^(?:--[\w-]+|var\(--[\w-]+(?:\s*,[^)]+)?\))$/

// Checks whether string is a valid CSS value unit or a CSS variable
export function isCssValue(value: string): boolean {
  return unitRegex.test(value) || variableRegex.test(value)
}

/**
 * Takes in a value and if it is a number, appends "px" to it, otherwise returns
 * the original value.
 *
 */
export function formatUnitValue(value: string | number, unit: string = 'px'): string {
  if (typeof value === 'number') {
    return `${value}${unit}`
  }

  const trimmedValue = value.trim()

  return isCssValue(trimmedValue) ? trimmedValue : `${trimmedValue}${unit}`
}

export function clamp(min: number, max: number, value: number): number {
  return Math.min(Math.max(value, min), max)
}

export function getPlacementAnimationName(position: Placement): string {
  const suffix = position.includes('-') ? position.split('-')[0] : position
  return `fade-${suffix}`
}
